// import bangaloreImage from '../assets/Place.jpg'; // Adjust the path based on your folder structure


// const Place = () => {
//   const places = [
//     { id: 1, name: 'Bangalore', image: bangaloreImage },
//     { id: 2, name: 'Bangalore', image: bangaloreImage },
//     { id: 3, name: 'Bangalore', image: bangaloreImage },
//     { id: 4, name: 'Bangalore', image: bangaloreImage },
//     { id: 5, name: 'Bangalore', image: bangaloreImage },
//     { id: 6, name: 'Bangalore', image: bangaloreImage },
//     { id: 7, name: 'Bangalore', image: bangaloreImage },
//     { id: 8, name: 'Bangalore', image: bangaloreImage },
//     { id: 9, name: 'Bangalore', image: bangaloreImage },
//     { id: 10, name: 'Bangalore', image: bangaloreImage },
//     { id: 11, name: 'Bangalore', image: bangaloreImage },
//     { id: 12, name: 'Bangalore', image: bangaloreImage },
//     { id: 13, name: 'Bangalore', image: bangaloreImage },
//     { id: 14, name: 'Bangalore', image: bangaloreImage },
//     { id: 15, name: 'Bangalore', image: bangaloreImage },
//     { id: 16, name: 'Bangalore', image: bangaloreImage },
//     { id: 17, name: 'Bangalore', image: bangaloreImage },
//     { id: 18, name: 'Bangalore', image: bangaloreImage },
//     { id: 19, name: 'Bangalore', image: bangaloreImage },
//     { id: 20, name: 'Bangalore', image: bangaloreImage },
//     { id: 21, name: 'Bangalore', image: bangaloreImage },
//     { id: 22, name: 'Bangalore', image: bangaloreImage },
//     { id: 23, name: 'Bangalore', image: bangaloreImage },
//     { id: 24, name: 'Bangalore', image: bangaloreImage },
//     { id: 25, name: 'Bangalore', image: bangaloreImage },
   
//   ];

//   return (
//     <div className="max-w-screen-xl mx-auto px-4 py-8">
//       <h2 className="text-3xl font-semibold text-center text-[#FF9630] mb-8">
//         Spot to visit <span className="text-[#FF9630]">•</span>
//       </h2>

//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
//         {places.map((place) => (
//           <div key={place.id} className="flex flex-col items-center">
//             {/* Image Card */}
//             <div className="relative bg-white rounded-lg overflow-hidden transition-shadow w-full">
//               <img
//                 src={place.image}
//                 alt={`Scenic view of ${place.name}`}
//                 className="w-full h-48 object-cover"
//               />
//               <div className="absolute top-2 right-2 bg-white text-[#FF9630] text-xs font-semibold py-1 px-2 rounded cursor-pointer hover:bg-white">
//                 MAP 
//               </div>
//             </div>
//             {/* Place Name */}
//             <div className="mt-2 text-lg font-medium text-gray-700">{place.name}</div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Place;


import bangaloreImage from '../assets/Place.jpg'; // Adjust the path based on your folder structure
import { MdOutlineArrowOutward } from 'react-icons/md';

const Place = () => {
  const places = [
    { id: 1, name: 'Bangalore', image: bangaloreImage },
    { id: 2, name: 'Bangalore', image: bangaloreImage },
    { id: 3, name: 'Bangalore', image: bangaloreImage },
    { id: 4, name: 'Bangalore', image: bangaloreImage },
    { id: 5, name: 'Bangalore', image: bangaloreImage },
    { id: 6, name: 'Bangalore', image: bangaloreImage },
    { id: 7, name: 'Bangalore', image: bangaloreImage },
    { id: 8, name: 'Bangalore', image: bangaloreImage },
    { id: 9, name: 'Bangalore', image: bangaloreImage },
    { id: 10, name: 'Bangalore', image: bangaloreImage },
    { id: 11, name: 'Bangalore', image: bangaloreImage },
    { id: 12, name: 'Bangalore', image: bangaloreImage },
    { id: 13, name: 'Bangalore', image: bangaloreImage },
    { id: 14, name: 'Bangalore', image: bangaloreImage },
    { id: 15, name: 'Bangalore', image: bangaloreImage },
    { id: 16, name: 'Bangalore', image: bangaloreImage },
    { id: 17, name: 'Bangalore', image: bangaloreImage },
    { id: 18, name: 'Bangalore', image: bangaloreImage },
    { id: 19, name: 'Bangalore', image: bangaloreImage },
    { id: 20, name: 'Bangalore', image: bangaloreImage },
    { id: 21, name: 'Bangalore', image: bangaloreImage },
    { id: 22, name: 'Bangalore', image: bangaloreImage },
    { id: 23, name: 'Bangalore', image: bangaloreImage },
    { id: 24, name: 'Bangalore', image: bangaloreImage },
  
  ];

  return (
    <div className="max-w-screen-2xl  px-4 md:px-16 py-8 ">
      <h2 className="text-3xl font-semibold text-center text-[#FF9630] mb-8">
        Spot To Visit <span className="text-[#FF9630]"></span>
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
        {places.map((place) => (
          <div key={place.id} className="flex flex-col items-center">
            {/* Image Card */}
            <div className="relative bg-white rounded-lg overflow-hidden transition-shadow w-full">
              <img
                src={place.image}
                alt={`Scenic view of ${place.name}`}
                className="w-full md:h-48 h-32 object-cover"
              />
              <div className="absolute top-2 right-2 flex items-center gap-1 bg-white text-[#FF9630] text-xs font-semibold py-1 px-2 rounded cursor-pointer hover:bg-white">
                MAP <MdOutlineArrowOutward className="text-[#FF9630]" />
              </div>
            </div>
            {/* Place Name */}
            <div className="mt-2 text-lg font-medium text-gray-700">{place.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Place;
